module.exports = __webpack_public_path__ + "assets/4195d02265cfff1d729305ce647b5933.svg";